import { useEffect, useState } from 'react'

export function SplashScreen({ onComplete }: { onComplete: () => void }) {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false)
      setTimeout(onComplete, 400)
    }, 1800)
    return () => clearTimeout(timer)
  }, [onComplete])

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: '#1B3A2D',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '24px',
        zIndex: 9999,
        transition: 'opacity 0.4s ease',
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'all' : 'none',
      }}
    >
      <img
        src="/icons/any/icon-192.png"
        alt="DoublePress"
        style={{ width: 96, height: 96, borderRadius: '22px' }}
      />
      <div style={{ textAlign: 'center' }}>
        <p style={{
          color: '#ffffff',
          fontSize: '22px',
          fontWeight: 600,
          margin: 0,
          letterSpacing: '-0.01em',
        }}>
          Every bet tracked.
        </p>
        <p style={{
          color: '#D4AF37',
          fontSize: '22px',
          fontWeight: 600,
          margin: 0,
          letterSpacing: '-0.01em',
        }}>
          Every hole settled.
        </p>
      </div>
    </div>
  )
}
